import React from 'react';
import tagularEvent from '@/utils/tagular/tagularEvent';
import uuid from '@/utils/uuid';
import { Occupation } from '../types';
import numberFormatter from '@/utils/numberFormatter';

interface OccupationCardProps {
  occupation: Occupation;
  isSelected: boolean;
  index: number;
  onSelect: (occupation: Occupation) => void;
  employmentChange?: string;
}

const OccupationCard: React.FC<OccupationCardProps> = ({
  occupation,
  isSelected,
  index,
  onSelect,
}) => {
  const { currencyFormat } = numberFormatter();
  const handleCardClick = () => {
    // Fire the element clicked event first
    tagularEvent('ElementClicked', {
      correlationId: uuid(),
      webElement: {
        elementType: 'button',
        location: 'salary-calculator',
        name: 'career-card',
        text: occupation?.title,
        position: (index + 1).toString(),
      },
    });

    onSelect(occupation);
  };

  return (
    <div
      className={`flex flex-col justify-between bg-white rounded-lg border py-3 px-4 hover:cursor-pointer hover:shadow-md transition-shadow duration-200 ${
        isSelected
          ? 'outline outline-2 outline-primary-500 outline-offset-[-2px]'
          : ''
      }`}
      onClick={handleCardClick}
      data-occupation-code={occupation.onetSocCode}
    >
      <div className='flex items-center mb-3'>
        <div className='font-body-14 md:font-body-16 font-bold'>
          {occupation.title}
        </div>
      </div>

      <div className='flex flex-row items-center'>
        <div className='hidden md:flex bg-primary-50 w-7 h-7 rounded-full mr-2 items-center justify-center'>
          <span className='text-center'>$</span>
        </div>
        <div>
          <div className='text-gray-600 font-body-10 md:font-body-14'>
            Avg. Annual Salary
          </div>
          {occupation.salary && occupation.salary > 0 && (
            <div className='font-body-18 md:font-body-24 font-bold'>
              {currencyFormat?.format(occupation.salary)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OccupationCard;
